import React from 'react';

const SearchBox = ({ searchField, searchChange }) => {
  return (
    <div className='pa2'>
      <input
          className='pa3 ba b--blue'
               type='search' 
        placeholder='search robot' 
        onChange={ searchChange }
      />
    </div>
  );
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/SearchBox.js